import { Check, Circle, RadioButton } from "phosphor-react";
import React from "react";

export const RadioIndicator: React.FC<{ selected: boolean }> = ({
  selected,
}) =>
  selected ? (
    <RadioButton size={18} weight="fill" className="text-brand shrink-0" />
  ) : (
    <Circle size={18} className="text-secondary shrink-0" />
  );

export const CheckIndicator: React.FC<{ checked: boolean }> = ({ checked }) => (
  <div
    className={`w-4 h-4 rounded border border-solid flex items-center justify-center shrink-0 transition-colors duration-200 ${
      checked ? "bg-brand border-brand" : "border-secondary bg-primary"
    }`}
  >
    {checked && <Check size={10} weight="bold" className="text-white" />}
  </div>
);
